import { render, staticRenderFns } from "./adv-manage.vue?vue&type=template&id=4c17f324&"
import script from "./adv-manage.vue?vue&type=script&lang=js&"
export * from "./adv-manage.vue?vue&type=script&lang=js&"
import style0 from "./adv-manage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports